/**
 * Incrementally parse SSE `data:` payloads from a text buffer (events separated by blank lines).
 */
export function drainSseBuffer(buffer: string): { payloads: string[]; remainder: string } {
  const parts = buffer.split('\n\n');
  const remainder = parts.pop() || '';
  const payloads: string[] = [];

  for (const part of parts) {
    if (part.startsWith(':')) {
      continue;
    }
    const dataLine = part.split('\n').find((line) => line.startsWith('data:'));
    if (!dataLine) {
      continue;
    }
    payloads.push(dataLine.replace(/^data:\s?/, '').trim());
  }

  return { payloads, remainder };
}
